/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 *   let quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.Shopify.getCart = async function () {
  let fetchUrl = Shopify.routes.root + "cart.js";

  let response = await fetch(fetchUrl, {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
    },
  });

  let cart = await response.json();

  return cart;
};

window.addEventListener("DOMContentLoaded", function () {
  // Hide Rewards Toggle
  setTimeout(() => {
    if (!window.jQuery("body").hasClass("hide-rewards")) {
      window.defer(() => {
        const targetNode = document.querySelector(
          ".upez--inner-drawer-container",
        );
        const config = { attributes: true, childList: true, subtree: false };
        const callback = (mutationList, observer) => {
          for (const mutation of mutationList) {
            console.log("Rewards toggle mutation");
            const cartIsOpen = $(".upez--inner-drawer-container").attr(
              "cart-open",
            );

            if (
              cartIsOpen == "true" &&
              !window.jQuery("body").hasClass("hide-rewards")
            ) {
              window.jQuery("body").addClass("hide-rewards");
            }
          }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }, "#upezCart .upez--inner-drawer-container");
    }
  }, 1000);

  function addToCartFromForm($elem, additionalData = {}) {
    var variantId =
      $elem.attr("data-variant-id") ?? window.jQuery("select[name='id']").val();
    var variant = window.PDP.productData.variants.find(function (variant) {
      return +variant.id === +variantId;
    });

    var qty = $elem.attr("data-qty") ?? 1;
    var referrer = $elem.attr("data-referrer");
    var isSubscription =
      window.jQuery("[data-selector-subsave] input:checked").length > 0;
    var sellingPlan = isSubscription
      ? {
          name: window
            .jQuery(".subscription-options .rc_widget__option__selector input")
            .eq(0)
            .attr("name"),
          selectedValue: window
            .jQuery(".Product .rc_widget__option__plans__dropdown")
            .eq(0)
            .val(),
        }
      : {};
    if (
      referrer === "scroll-subnav" &&
      !window.PDP.variantsInteracted &&
      window.jQuery(".shade-selector-modal__wrapper").length
    ) {
      window
        .jQuery(".shade-selector-modal__bg, .shade-selector-modal__wrapper")
        .toggleClass("visible", true);
      window.jQuery("html").toggleClass("no-scroll", true);
      window.jQuery("body").toggleClass("shade-selector-open", true);
      moveSecondarySubscriptionWidget();
    } else {
      if (referrer === "shade-selector-modal") {
        window
          .jQuery(".shade-selector-modal__bg, .shade-selector-modal__wrapper")
          .toggleClass("visible", false);
        window.jQuery("html").toggleClass("no-scroll", false);
        window.jQuery("body").toggleClass("shade-selector-open", false);
      }

      return addToCartWithCartUpdate(
        variant,
        qty,
        isSubscription,
        sellingPlan,
        additionalData,
      );
    }
  }

  function setHeaderHeightProperties() {
    window.jQuery("html").css({
      "--header-height":
        window.jQuery("#section-medispa-header,#section-header").outerHeight() +
        "px",
      "--secondary-nav-height":
        window.jQuery("nav.Header__MainNav").outerHeight() + "px",
      "--subnav-height": window.jQuery(".Header__MainNav").outerHeight() + "px",
    });
  }

  window.jQuery(document).ready(function () {
    setHeaderHeightProperties();

    window.jQuery(window).on("resize", function (e) {
      setHeaderHeightProperties();
    });

    // Disable defaults for nav items
    window.jQuery('[aria-haspopup="true"] a').on("click", function (e) {
      var $elem = window.jQuery(this);
      if ($elem.hasClass("ttt") || $elem.siblings(".DropdownMenu").length)
        e.preventDefault();
    });

    window.jQuery(".collection-description").click(function (event) {
      event.preventDefault();
      var Ele = window.jQuery(this);
      if (Ele.hasClass("inline")) {
        window.jQuery(this).removeClass("inline");
        window.jQuery(this).text("Read Less");
        window.jQuery(".SectionHeader__Description").removeClass("inline");
      } else {
        window.jQuery(this).addClass("inline");
        window.jQuery(this).text("Read More");
        window.jQuery(".SectionHeader__Description").addClass("inline");
      }
    });
  });

  window.jQuery("body").on("click", ".js-action", function (e) {
    if (!window.jQuery(this).hasClass("allow-propagation")) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    var $elem = window.jQuery(this);
    var action = $elem.attr("data-action");

    if (!action) return;

    switch (action) {
      case "open-modal": {
        var target = $elem.attr("data-target");
        var $target = window.jQuery(target);
        if (!$target.length) return;
        $target.toggleClass("visible", true);
        break;
      }
      case "close-modal": {
        var target = $elem.attr("data-target");
        var $target = window.jQuery(target);
        if (!$target.length) return;
        $target.toggleClass("visible", false);
        window.jQuery("html").toggleClass("no-scroll", false);

        $target.find("video").trigger("pause");
        break;
      }
      case "close-modal-self": {
        var $target = $elem;
        if (!$target.length) return;
        $target.toggleClass("visible", false);
        window.jQuery("html").toggleClass("no-scroll", false);

        $target.find("video").trigger("pause");
        break;
      }
      case "toggle-tab": {
        var targetSelector = $elem.attr("data-target");
        var $scope = window.jQuery($elem.attr("data-scope")) || $elem.parent();
        $scope.find(".tab-header").each(function (idx, elem) {
          var $elem = window.jQuery(elem);
          $elem.toggleClass("active", false);
          var elemTarget = $elem.attr("data-target");
          window.jQuery(elemTarget).toggleClass("active", false);
        });
        var target = $scope.find(targetSelector);
        window.jQuery(this).toggleClass("active", true);
        target.toggleClass("active", true);
        var $parent = window.jQuery(this).parent();
        var parent = $parent.get(0);
        var activeItem = $parent.find(".active").get(0);
        var numTabs = $parent.find(".tab-header").length;
        var activeItemWidth =
          window.jQuery(activeItem).index() === numTabs - 1
            ? parent.getBoundingClientRect().width - activeItem.offsetLeft
            : activeItem.offsetLeft + activeItem.getBoundingClientRect().width;
        var activeleftOffset =
          window.jQuery(activeItem).index() === 0 ? 0 : activeItem.offsetLeft;
        parent.style.setProperty("--num-tabs", numTabs);
        parent.style.setProperty("--active-item-width", activeItemWidth);
        parent.style.setProperty("--active-item-left-offset", activeleftOffset);
        break;
      }
      case "add-to-cart": {
        e.preventDefault();
        $("body").addClass("hide-rewards");

        // Purchase 3 to get gift modal
        window.PurchaseGiftManager.showModal().then(async function ({
          status,
        }) {
          if (status === "user-rejected") {
            return addToCartFromForm($elem);
          }

          let parsedGifts = await window.PurchaseGiftManager.parseCartGifts();

          if (status === "not-eligible") {
            return addToCartFromForm($elem);
          }

          if (status === "not-needed")
            return addToCartFromForm($elem, parsedGifts.notInCart.payload);

          if (status === "add-multiple")
            return window.PurchaseGiftManager.addRequiredForGiftToCart($elem);
        });
        break;
      }
      case "add-variant-to-cart": {
        var variantId = $elem.attr("data-variant-id");
        var qty = $elem.attr("data-qty");

        rawAddToCart(variantId, qty);
        $("body").addClass("hide-rewards");

        break;
      }
      case "change-swatch-group": {
        var group = $elem.attr("data-group");
        if (!group) clearSwatchFilters();
        else setSwatchFilter(group);
        $elem.siblings(".active").toggleClass("active", false);
        $elem.toggleClass("active", true);
        break;
      }
      case "change-carousel-position": {
        var $elem = window.jQuery(this);
        var imagePos = $elem.attr("data-image-position");
        var thumbs = window.jQuery(".product-image-thumbs-wrapper");
        var main = window.jQuery(".product-main-carousel-wrapper");
        thumbs.get(0).swiper.slideTo(+imagePos - 1);
        main.get(0).swiper.slideTo(+imagePos - 1);

        thumbs.get(0).swiper.updateProgress();
        main.get(0).swiper.updateProgress();
      }
      case "decrease-quantity":
      case "increase-quantity": {
        var updatedVal = $elem
          .siblings("input.product-form__quantity-input")
          .val();

        syncQuantities(updatedVal);
        break;
      }
      case "open-calendar": {
        //   var productId = $elem.attr("data-product-id");
        //   var variantId = $elem.attr("data-variant-id");

        //   window.jQuery("#sesami-form input[name='id']").attr("data-productid", productId);
        //   window.jQuery("#sesami-form input[name='id']").attr("value", variantId);
        //   window.jQuery("#sesami-form input[name='id']").val(variantId);

        //   window.jQuery("sesami-calendar").attr("product-id", productId);
        //   window.jQuery("sesami-calendar").attr("variant-id", variantId);
        //   window.jQuery("sesami-calendar").get(0).disableSesamiButton = false;

        //   window.jQuery("sesami-calendar").get(0).startTimeZone =
        //     Intl.DateTimeFormat().resolvedOptions().timeZone;
        //   // window.jQuery("sesami-calendar").get(0).setSesami();
        //   window.jQuery("sesami-calendar").get(0).openCalendar();
        //   // window.dispatchEvent(new CustomEvent("show-modal-sesami"));

        let products = [];
        let defaultSelection = $elem.attr("data-product-id");
        let title = $elem.attr("data-product-title");

        $elem
          .closest(".medispa-dropdown-options")
          .find("> a")
          .each(function () {
            products.push({
              id: window.jQuery(this).attr("data-product-id"),
              variant_id: window.jQuery(this).attr("data-variant-id"),
              name: window.jQuery(this).find("li").text().trim(),
            });
          });

        products.push({
          id: $elem.attr("data-product-id"),
          variant_id: $elem.attr("data-variant-id"),
          name: "Henry House",
          price: $elem.attr("data-product-price"),
        });

        generateCalendarPopup(products, defaultSelection, title);

        break;
      }
      case "open-call-modal": {
        window
          .jQuery(".generic-overlay-bg, .call-us-modal__wrapper")
          .toggleClass("visible");
        break;
      }
      case "watch-video": {
        try {
          var videoConfig = JSON.parse(
            decodeURIComponent($elem.data("videoConfig")),
          );

          var sourcesHtml = videoConfig.sources
            .map(function (source) {
              if (!source.url || !source.mime_type) return "";

              return `<source src="${source.url}" type="${source.mime_type}">`;
            })
            .join("");

          var $existingPlayer = window.jQuery(".video-overlay__wrapper");

          if ($existingPlayer.length) {
            $existingPlayer.find("video source").remove();
            $existingPlayer.find("video").html(sourcesHtml);
            $existingPlayer
              .find("video")
              .attr("width", videoConfig.sources[0].width);
            $existingPlayer
              .find("video")
              .attr("height", videoConfig.sources[0].height);
          } else {
            $existingPlayer = window
              .jQuery(
                `<div class="video-overlay__wrapper">
            <video autoplay controls width="{{WIDTH}}" height="{{HEIGHT}}">
                {{SOURCES}}
                Your browser does not support the video tag.
            </video>
        </div>`
                  .replace(/{{WIDTH}}/g, videoConfig.sources[0].width)
                  .replace(/{{HEIGHT}}/g, videoConfig.sources[0].height)
                  .replace(/{{SOURCES}}/g, sourcesHtml),
              )
              .appendTo("body");
          }

          $existingPlayer.css("--aspect-ratio", videoConfig.aspect_ratio);

          $existingPlayer.toggleClass("visible", true);
          window.jQuery(".generic-overlay-bg").toggleClass("visible", true);

          window.jQuery(".generic-overlay-bg").one("click", function (e) {
            window.jQuery(".generic-overlay-bg").toggleClass("visible", false);
            $existingPlayer.toggleClass("visible", false);
            $existingPlayer.find("video").get(0).pause();
          });

          break;
        } catch (err) {
          throw err;
        }
      }
      case "select-options": {
        var productId = $elem.attr("data-product-id");
        if (!productId) return;

        window.selectOptionsHandler.handleRequest(productId);
        break;
      }
      case "add-required-to-cart": {
        e.preventDefault();
        return window.PurchaseGiftManager.addRequiredForGiftToCart($elem);
      }
      default: {
        console.debug("Unhandled JS event: ", action);
        break;
      }
    }
  });

  window.jQuery(".medispa-dropdown-trigger").on("click", function (e) {
    window.jQuery(this).toggleClass("open");
    window.jQuery(this).closest(".booking-wrapper").toggleClass("open");
  });

  function rawAddToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    }).then((resp) => resp.json());
  }

  function __addToCart(
    variant,
    quantity,
    isSubscription,
    sellingPlan,
    additionalData,
  ) {
    return new Promise(function (resolve, reject) {
      let payload = {
        form_type: 'product',
        utf8: '✓',
        items: [
          {
            properties: {
              _barcode: variant.sku,
            },
            id: variant.id,
            quantity: quantity,
          },
        ],
      };

      if (additionalData?.length) {
        payload.items.push(...additionalData);
      }

      if (quantity >= window.theme.gift_product.required_amount) {
        payload.items[0].properties["_promotion"] = "b3g3";
      }

      payload[sellingPlan.name] = isSubscription ? "subsave" : "onetime";
      if (isSubscription) payload["selling_plan"] = sellingPlan.selectedValue;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((resp) => resp.json())
        .then(resolve)
        .catch(reject);
    });
  }

  function addToCartWithCartUpdate(
    variant,
    qty,
    isSubscription,
    sellingPlan,
    additionalData,
  ) {
    return new Promise(function (resolve, reject) {
      try {
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        __addToCart(variant, qty, isSubscription, sellingPlan, additionalData)
          .then(function () {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            document.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  variant: variant,
                  quantity: qty,
                },
              }),
            );
          })
          .then(resolve)
          .catch(function (err) {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            console.debug(err?.responseJSON);
            console.trace(err);

            reject(err.responseJSON.description);
          });
      } catch (e) {
        reject(e);
      }
    });
  }

  function clearSwatchFilters() {
    window
      .jQuery("label.ColorSwatch[data-category]")
      .each(function (idx, elem) {
        window.jQuery(elem).closest(".js-variant").toggleClass("hidden", false);
      });
  }

  function syncQuantities(newQuantity) {
    window
      .jQuery(".product-form__quantity input.product-form__quantity-input")
      .val(newQuantity);
    window
      .jQuery(".product-form__add-to-cart[data-action='add-to-cart'][data-qty]")
      .attr("data-qty", newQuantity);
  }

  window.jQuery(".product-form__quantity-input").on("change", function (e) {
    let updatedVal = window.jQuery(this).val();

    syncQuantities(updatedVal);
  });

  function setSwatchFilter(group) {
    window
      .jQuery("label.ColorSwatch[data-category]")
      .each(function (idx, elem) {
        var elemGroups = elem.dataset.category.split("$$");
        var matchesFilter = elemGroups.indexOf(group) !== -1;
        window
          .jQuery(elem)
          .closest(".js-variant")
          .toggleClass("hidden", !matchesFilter);
      });
  }

  document.addEventListener("variant:changed", function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    window
      .jQuery(".product-form__quantity input.product-form__quantity-input")
      .val(1);

    window.PurchaseGiftManager.onVariantChange(variant);
  });

  function updateRecentProducts() {
    var isPDP = !!document.querySelector("body.template-product");

    if (!isPDP) return;

    var productHandle = window.location.pathname.split("/").pop();

    var existingEntries = localStorage.getItem("recently-viewed-products");

    existingEntries = existingEntries ? JSON.parse(existingEntries) : [];

    // Remove existing versions of this handle from the list
    existingEntries = existingEntries.filter(function (entry) {
      return entry !== productHandle;
    });

    existingEntries.unshift(productHandle);

    localStorage.setItem(
      "recently-viewed-products",
      JSON.stringify(existingEntries),
    );
  }

  updateRecentProducts();

  function moveSecondarySubscriptionWidget() {
    let isMobile = window.jQuery(window).outerWidth() < 960;

    if (
      isMobile &&
      window.jQuery(".scroll-subnav .subscription-options").length
    ) {
      window
        .jQuery(".scroll-subnav .subscription-options")
        .insertBefore(
          ".ProductForm__AddToCart[data-referrer='shade-selector-modal']",
        );
    } else if (
      !isMobile &&
      window.jQuery(".shade-selector-modal__wrapper .subscription-options")
        .length
    ) {
      window
        .jQuery(".shade-selector-modal__wrapper .subscription-options")
        .insertBefore(".scroll-subnav .product-actions");
    }
  }

  window.jQuery(window).on("resize", moveSecondarySubscriptionWidget);

  // Emphasise BNDL code
  window.defer(function () {
    var widgetDescription = window.jQuery(
      ".widget-type-dynamic-bundle .rebuy-widget-container.is-visible .rebuy-widget-content .description",
    );

    widgetDescription.html(
      widgetDescription
        .html()
        .replace(/BNDL/g, "<strong class='bundle-code'>BNDL</strong>"),
    );
  }, ".widget-type-dynamic-bundle .rebuy-widget-container.is-visible .rebuy-widget-content .description");
});
